// src/hooks/portfolio/usePortfolioNav.ts

import { useQuery } from "@tanstack/react-query";
import { portfolioNavQueryOptions } from "@/services/queries/portfolioQueries";

export const usePortfolioNav = (authToken?: string) => {
  return useQuery(portfolioNavQueryOptions(authToken));
};


